<script setup lang="ts">
import { useUndoStore } from 'shared/undo/stores/undoStore';
import { storeToRefs } from 'pinia';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { ref } from 'vue';
import { useOnKeyboardAction } from '../../vehicles/composables/useOnKeyBoardAction';
import { KeyboardActions } from '../../vehicles/domain/keyboardActions';

const props = defineProps<Props>();

const undoStore = useUndoStore();
const { title, description, hasUndo } = storeToRefs(undoStore);
const visible = ref(false);
const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const loading = ref(false);

async function onExecuteUndoClick() {
  try {
    loading.value = true;
    await undoStore.executeUndo();
  } finally {
    loading.value = false;
    visible.value = false;
  }
}

function showDialog() {
  visible.value = true;
}

interface Props {
  size?: 'small' | undefined
};

useOnKeyboardAction(KeyboardActions.Undo, () => {
  if(hasUndo.value) {
    showDialog();
  }

});

</script>

<template>
  <Button :size="props.size" :disabled="!hasUndo" :label="translations.undo.undoBtn" v-tooltip.bottom="title"
    icon="pi pi-undo" @click="showDialog">
  </Button>
  <Dialog v-model:visible="visible" :header="title" :style="{ width: '25rem' }" position="center" :modal="false"
    :draggable="false" @keydown.enter="onExecuteUndoClick">
    <div class="text-surface-500 dark:text-surface-400 mb-8">{{ description }}</div>
    <div class="flex justify-end gap-2">
      <Button type="button" :label="translations.generic.confirm" @click="onExecuteUndoClick"
        :loading="loading"></Button>
      <Button type="button" :label="translations.generic.cancel" severity="danger" @click="visible = false"></Button>
    </div>
  </Dialog>
</template>

<style scoped lang="css"></style>
